import { IconWrapper } from './IconWrapper'
import { IIconProps } from './props'

export function WifiIcon(props: IIconProps) {
  return (
    <IconWrapper {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 16.875C10.5178 16.875 10.9375 16.4553 10.9375 15.9375C10.9375 15.4197 10.5178 15 10 15C9.48223 15 9.0625 15.4197 9.0625 15.9375C9.0625 16.4553 9.48223 16.875 10 16.875Z"
          fill="currentColor"
        />
        <path
          d="M18.125 7.28071C15.8341 5.40184 12.9628 4.375 10 4.375C7.03717 4.375 4.1659 5.40184 1.875 7.28071"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.625 10.0781C14.024 8.81068 12.0419 8.12109 10 8.12109C7.95807 8.12109 5.97599 8.81068 4.375 10.0781"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.125 12.8908C12.2169 12.2303 11.1229 11.8745 10 11.8745C8.8771 11.8745 7.78308 12.2303 6.875 12.8908"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  )
}
